import React, { useEffect, useState } from 'react';
import infoSvg from './blankslate-info-icon.svg'
import {
  BlankSlate,
  PrimaryActionButton,
} from '@cjdev/visual-stack/lib/components/BlankSlate'
import '@cjdev/visual-stack/lib/css/base.css'
import '@cjdev/visual-stack/lib/css/bootstrap-cj.css'
import '@cjdev/visual-stack/lib/css/forms.css'
import '@cjdev/visual-stack/lib/css/layout.css'
import '@cjdev/visual-stack/lib/css/globalVariables.css'
import { Row } from '@cjdev/visual-stack/lib/components/List'

export const FederatedUserInvitationStatus = ({userServiceRootUrl, token }) => {

  const [fetchError, setFetchError] = useState(false)
  const [invitationData, setInvitationData] = useState(null)

  useEffect(() => {
    async function getInvitationData() {
      if ( token ) {
        try {
          const encodedToken = encodeURIComponent(token)
          const getUrl = `${userServiceRootUrl}/api/invitations/federated-users/token/${encodedToken}`
          const response =  await fetch(getUrl, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
          if (!response.ok) {
             setFetchError(true)
          } else {
              setFetchError(false)
          }
          const invitation = await response.json();
          setInvitationData(invitation)
        } catch (e ) {
          console.error("Error fetching invitation data: ", e)
        }
      }
    }
    getInvitationData()
  }, [userServiceRootUrl, token])

  const title = (invitation) => {
    const prefix = "Invitation Status: "
    if ( !invitation || fetchError ) {
      return prefix
    }
    const status = invitation.status.toLowerCase()
    return `${prefix} ${status.charAt(0).toUpperCase() + status.slice(1)}`
  }

  const DescriptionMessage = ({status}) => {
    switch (status) {
      case 'ACCEPTED':
        return <div>Your invitation has been accepted. You can now log in using your federated credentials.</div>
      case 'REJECTED':
        return <div>
          <div>Please contact support if you did not expect an invitation if you have any concerns.</div>
          <div>If you declined by mistake please contact support.</div>
        </div>
      case 'REVOKED':
        return <div>Your invitation has been revoked. Please contact support for further assistance.</div>
      case 'EXPIRED':
        return <div>Your invitation has expired. Please request a new invitation to proceed.</div>
      case 'CREATED':
        return <div>Your invitation is pending. Please check your email for further instructions to accept the invitation.</div>
      default:
        return <div>An unknown error occurred. Please contact your administrator for assistance.</div>
    }
  }

  const NextAction = ({status}) => {
    if (status === 'ACCEPTED') {
      return (
        <Row justify={"center"} gap={'large'}>
          <PrimaryActionButton
            label={'Proceed to CJ Affiliate'}
            handler={() => window.location.href = 'https://members.cj.com/member/login'}
          />
          <PrimaryActionButton
            label={'Proceed to Meta'}
            handler={() => window.location.href = 'https://www.meta.com'}
          />
        </Row>
      )
    }
    return <></>
  }

  return (
    <BlankSlate
      title={title(invitationData)}
      headerGraphic={
        <img
          src={infoSvg}
          alt={'error graphic'}
          className={'headerGraphic'}
        />
      }
    >
      { invitationData &&
        <DescriptionMessage
          status={invitationData.status}
        />
      }
      { invitationData && invitationData.status === 'ACCEPTED' &&
        <NextAction status={invitationData.status} />
      }
      { fetchError &&
        <div>Invitation not found. Contact support</div>
      }
    </BlankSlate>
  )
}
